var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcMagpie(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 94,
    height: 100,
    viewBox: "0 0 94 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.0496 27.3167C12.8957 29.9782 13.0986 32.6676 13.6756 35.3187L17.2462 38.8453L14.3051 37.7117C14.6548 38.8488 15.0779 39.9755 15.5745 41.0813L19.7466 44.2452L16.6342 43.2126C16.9594 43.8091 17.3056 44.3986 17.6763 44.9812C26.5205 58.7947 44.9119 62.8411 58.7605 54.0193C61.8485 52.0519 64.4503 49.6101 66.5276 46.8509C46.9018 49.5648 26.6744 42.5255 13.0461 27.3201L13.0496 27.3167Z",
    fill: "url(#paint0_linear_9025_364538)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M80.9504 27.3167C81.1043 29.9782 80.9015 32.6676 80.3244 35.3187L76.7539 38.8453L79.695 37.7117C79.3453 38.8488 78.9221 39.9755 78.4255 41.0813L74.2534 44.2452L77.3659 43.2126C77.0407 43.8091 76.6944 44.3986 76.3237 44.9812C67.4795 58.7947 49.0881 62.8411 35.2395 54.0193C32.1516 52.0519 29.5497 49.6101 27.4724 46.8509C47.0983 49.5648 67.3256 42.5255 80.9539 27.3201L80.9504 27.3167Z",
    fill: "url(#paint1_linear_9025_364538)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M46.9782 54.8767C36.4204 54.8767 27.2614 48.9188 22.6907 40.1912C25.4534 51.0048 35.2803 58.9998 46.9782 58.9998C58.6761 58.9998 68.5065 51.0048 71.2657 40.1912C66.6915 48.9188 57.5325 54.8767 46.9782 54.8767Z",
    fill: "url(#paint2_linear_9025_364538)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M46.9782 54.8776C57.536 54.8776 66.695 48.9196 71.2657 40.192C71.7728 38.2107 72.0421 36.1386 72.0421 34.0003C72.0421 20.1938 60.8198 9 46.9782 9C33.1366 9 21.9143 20.1938 21.9143 34.0003C21.9143 36.1386 22.1836 38.2107 22.6907 40.192C27.2649 48.9196 36.4239 54.8776 46.9782 54.8776Z",
    fill: "url(#paint3_linear_9025_364538)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M35.5569 42.5356C41.1676 42.5356 45.716 37.9987 45.716 32.4022C45.716 26.8057 41.1676 22.2688 35.5569 22.2688C29.9461 22.2688 25.3977 26.8057 25.3977 32.4022C25.3977 37.9987 29.9461 42.5356 35.5569 42.5356Z",
    fill: "white",
    stroke: "#084E80",
    strokeWidth: 0.57,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M38.005 38.7092C41.047 38.7092 43.513 36.2495 43.513 33.2152C43.513 30.1809 41.047 27.7212 38.005 27.7212C34.9631 27.7212 32.4971 30.1809 32.4971 33.2152C32.4971 36.2495 34.9631 38.7092 38.005 38.7092Z",
    fill: "#1370A7"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M38.0047 36.756C39.965 36.756 41.5542 35.1708 41.5542 33.2154C41.5542 31.26 39.965 29.6748 38.0047 29.6748C36.0443 29.6748 34.4551 31.26 34.4551 33.2154C34.4551 35.1708 36.0443 36.756 38.0047 36.756Z",
    fill: "#0B1A2B"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M35.9984 31.5582C36.6203 31.5582 37.1245 31.0553 37.1245 30.435C37.1245 29.8147 36.6203 29.3118 35.9984 29.3118C35.3765 29.3118 34.8723 29.8147 34.8723 30.435C34.8723 31.0553 35.3765 31.5582 35.9984 31.5582Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M58.0964 42.5356C63.7071 42.5356 68.2555 37.9987 68.2555 32.4022C68.2555 26.8057 63.7071 22.2688 58.0964 22.2688C52.4857 22.2688 47.9373 26.8057 47.9373 32.4022C47.9373 37.9987 52.4857 42.5356 58.0964 42.5356Z",
    fill: "white",
    stroke: "#084E80",
    strokeWidth: 0.57,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M55.6481 38.7092C58.6901 38.7092 61.1561 36.2495 61.1561 33.2152C61.1561 30.1809 58.6901 27.7212 55.6481 27.7212C52.6061 27.7212 50.1401 30.1809 50.1401 33.2152C50.1401 36.2495 52.6061 38.7092 55.6481 38.7092Z",
    fill: "#1370A7"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M55.6477 36.756C57.6081 36.756 59.1973 35.1708 59.1973 33.2154C59.1973 31.26 57.6081 29.6748 55.6477 29.6748C53.6873 29.6748 52.0981 31.26 52.0981 33.2154C52.0981 35.1708 53.6873 36.756 55.6477 36.756Z",
    fill: "#0B1A2B"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M53.6415 31.5582C54.2634 31.5582 54.7675 31.0553 54.7675 30.435C54.7675 29.8147 54.2634 29.3118 53.6415 29.3118C53.0195 29.3118 52.5154 29.8147 52.5154 30.435C52.5154 31.0553 53.0195 31.5582 53.6415 31.5582Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M49.4173 40.963L46.9938 37.3631C46.9134 37.2445 46.742 37.2445 46.6616 37.3631L44.2381 40.963L44.1821 41.0467L44.2556 41.1235L46.6826 43.6943C46.763 43.778 46.8959 43.778 46.9728 43.6943L49.3998 41.1235L49.4733 41.0467L49.4173 40.963Z",
    fill: "url(#paint4_linear_9025_364538)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M0 76.0249H4.91076L10.0992 88.0624H10.3192L15.5076 76.0249H20.4184V93.9386H16.5552V82.2777H16.3985L11.5235 93.8497H8.89215L4.01714 82.2332H3.86041V93.9386H0V76.0249ZM28.1722 94.1923C27.2704 94.1923 26.4675 94.0432 25.7636 93.7451C25.0597 93.4417 24.5015 92.9946 24.0891 92.4061C23.6849 91.8125 23.4814 91.0698 23.4814 90.1833C23.4814 89.438 23.6244 88.8103 23.9131 88.303C24.2018 87.7956 24.595 87.3877 25.0899 87.0791C25.5849 86.7705 26.1513 86.5378 26.7809 86.3782C27.4188 86.2213 28.087 86.1089 28.7854 86.0461C29.6075 85.965 30.2702 85.8892 30.7706 85.8186C31.2738 85.7428 31.6395 85.6329 31.8649 85.4865C32.0904 85.34 32.2059 85.1256 32.2059 84.8379V84.7856C32.2059 84.2312 32.0216 83.8023 31.6532 83.499C31.2903 83.1956 30.7761 83.0439 30.1079 83.0439C29.404 83.0439 28.8431 83.193 28.4252 83.4911C28.0073 83.784 27.7323 84.1501 27.5976 84.5921L23.9736 84.3123C24.1578 83.4964 24.518 82.7903 25.0569 82.1966C25.5959 81.5951 26.2915 81.1349 27.1439 80.8132C28.0018 80.4863 28.9944 80.3242 30.1244 80.3242C30.9081 80.3242 31.6615 80.4105 32.3763 80.5857C33.0995 80.7609 33.7401 81.0329 34.2983 81.399C34.862 81.7651 35.3074 82.2385 35.6318 82.8164C35.9563 83.3891 36.1185 84.0743 36.1185 84.8719V93.9334H32.4038V92.0714H32.2939C32.0656 92.4924 31.7632 92.8612 31.3837 93.1828C31.0043 93.4967 30.5479 93.7451 30.0117 93.9255C29.4783 94.1008 28.8624 94.1871 28.164 94.1871L28.1722 94.1923ZM29.2941 91.6216C29.8715 91.6216 30.3801 91.5144 30.8201 91.2973C31.2628 91.075 31.6092 90.7795 31.8594 90.4056C32.1124 90.0316 32.2361 89.6106 32.2361 89.1372V87.712C32.1151 87.7878 31.9447 87.8584 31.7302 87.9212C31.5212 87.9787 31.2848 88.0336 31.0208 88.0885C30.7568 88.1356 30.4929 88.1801 30.2289 88.2193C29.965 88.2533 29.7257 88.2873 29.5113 88.3161C29.0521 88.3814 28.6507 88.4834 28.307 88.622C27.9633 88.7633 27.6966 88.9515 27.5068 89.1895C27.3171 89.4223 27.2209 89.7152 27.2209 90.0656C27.2209 90.5729 27.4133 90.96 27.801 91.2293C28.1942 91.4908 28.6891 91.6242 29.2913 91.6242L29.2941 91.6216ZM46.05 99.2578C44.7797 99.2578 43.6936 99.0904 42.7863 98.7583C41.8844 98.4314 41.1668 97.9869 40.6333 97.4194C40.0999 96.8545 39.7535 96.219 39.594 95.5129L43.2179 95.0501C43.3279 95.3194 43.5039 95.5679 43.7431 95.8032C43.9823 96.036 44.2985 96.2243 44.689 96.3629C45.0877 96.5093 45.5716 96.5825 46.1435 96.5825C46.9959 96.5825 47.697 96.3838 48.2497 95.9889C48.8078 95.5992 49.0856 94.9428 49.0856 94.0197V91.5615H48.9206C48.7501 91.9354 48.4916 92.2885 48.1479 92.6206C47.8043 92.9527 47.3616 93.2247 46.8227 93.4339C46.2837 93.6431 45.6403 93.7477 44.8897 93.7477C43.8284 93.7477 42.8633 93.515 41.9944 93.0469C41.131 92.5735 40.4409 91.8544 39.9239 90.8867C39.4153 89.9139 39.1596 88.6822 39.1596 87.1942C39.1596 85.7061 39.4208 84.4012 39.9404 83.3813C40.4629 82.3614 41.1558 81.5978 42.0191 81.0904C42.8907 80.5831 43.8421 80.3294 44.8787 80.3294C45.6706 80.3294 46.3305 80.4576 46.8666 80.7138C47.4001 80.9649 47.829 81.2787 48.1535 81.6579C48.4861 82.0319 48.7391 82.398 48.9178 82.7589H49.0636V80.502H52.9542V94.0694C52.9542 95.2122 52.66 96.1693 52.0716 96.9382C51.4832 97.707 50.6693 98.285 49.6245 98.6694C48.5879 99.0591 47.3946 99.2552 46.0473 99.2552L46.05 99.2578ZM46.1325 90.9469C46.7649 90.9469 47.2983 90.7978 47.7328 90.4997C48.1727 90.1963 48.5109 89.7649 48.7446 89.2052C48.9838 88.6403 49.1021 87.963 49.1021 87.1759C49.1021 86.3887 48.9866 85.7061 48.7529 85.1282C48.5191 84.545 48.1837 84.0926 47.741 83.7736C47.3011 83.4519 46.7622 83.2924 46.1325 83.2924C45.5028 83.2924 44.9474 83.4597 44.5048 83.7919C44.0648 84.1188 43.7294 84.5738 43.5012 85.157C43.2757 85.7401 43.1602 86.4149 43.1602 87.1785C43.1602 87.9421 43.2729 88.6246 43.5012 89.1895C43.7349 89.7492 44.0676 90.1833 44.5048 90.4919C44.9474 90.7952 45.4891 90.9469 46.1325 90.9469ZM56.5947 98.978V80.502H60.4578V82.7589H60.6338C60.8043 82.398 61.0545 82.0293 61.3789 81.6579C61.7089 81.2787 62.1378 80.9649 62.6657 80.7138C63.1992 80.4576 63.8618 80.3294 64.6509 80.3294C65.682 80.3294 66.6306 80.5857 67.5023 81.0983C68.3739 81.6056 69.0695 82.3718 69.5892 83.3996C70.1116 84.4195 70.3701 85.7009 70.3701 87.2386C70.3701 88.7763 70.1171 90.0028 69.6057 91.0358C69.1025 92.0609 68.4151 92.8403 67.5463 93.3711C66.6801 93.8968 65.7123 94.1583 64.6399 94.1583C63.8783 94.1583 63.2322 94.038 62.6987 93.8C62.1708 93.562 61.7391 93.2613 61.4009 92.8978C61.0627 92.5317 60.807 92.1603 60.6283 91.7864H60.5073V98.978H56.5892H56.5947ZM60.4303 87.2203C60.4303 88.0206 60.5458 88.7162 60.7795 89.3098C61.0133 89.9035 61.3514 90.3689 61.7914 90.7011C62.2313 91.028 62.7702 91.1901 63.3999 91.1901C64.0295 91.1901 64.5767 91.0227 65.0194 90.6906C65.4593 90.3533 65.7948 89.8851 66.0202 89.2915C66.254 88.69 66.3694 87.9996 66.3694 87.2177C66.3694 86.4358 66.2567 85.7611 66.0285 85.17C65.8003 84.5816 65.4676 84.1214 65.0249 83.7893C64.585 83.4571 64.0405 83.2898 63.3971 83.2898C62.7537 83.2898 62.2203 83.4493 61.7776 83.7709C61.3432 84.0926 61.0078 84.5476 60.774 85.136C60.5403 85.7245 60.4248 86.4201 60.4248 87.2177L60.4303 87.2203ZM73.5019 93.9386V80.502H77.42V93.9386H73.5019ZM75.4706 78.7708C74.8876 78.7708 74.3872 78.5877 73.972 78.219C73.5623 77.845 73.3561 77.4005 73.3561 76.88C73.3561 76.3596 73.5623 75.9255 73.972 75.5594C74.39 75.1854 74.8904 74.9998 75.4706 74.9998C76.0507 74.9998 76.5511 75.1854 76.9608 75.5594C77.3788 75.9255 77.5877 76.3675 77.5877 76.88C77.5877 77.3926 77.3788 77.845 76.9608 78.219C76.5511 78.5851 76.0535 78.7708 75.4706 78.7708ZM87.5165 94.2001C86.062 94.2001 84.8136 93.9203 83.7633 93.3607C82.7212 92.7958 81.9183 91.9956 81.3547 90.9626C80.791 89.9244 80.5078 88.6979 80.5078 87.2805C80.5078 85.8631 80.7883 84.6862 81.3547 83.6402C81.9183 82.5967 82.713 81.7834 83.7358 81.2003C84.7669 80.6171 85.974 80.3268 87.3598 80.3268C88.2919 80.3268 89.158 80.4706 89.9636 80.7557C90.772 81.0355 91.4786 81.4592 92.078 82.024C92.6857 82.5889 93.1586 83.3002 93.4941 84.158C93.8323 85.0105 94 86.0069 94 87.1497V88.1722H82.0723V85.8631H90.3128C90.3128 85.327 90.1918 84.851 89.9444 84.4378C89.6996 84.0246 89.3587 83.7003 88.9243 83.4676C88.4953 83.2296 87.9949 83.1093 87.4257 83.1093C86.8566 83.1093 86.3039 83.2401 85.8447 83.5042C85.3911 83.7605 85.0364 84.1083 84.7779 84.545C84.5194 84.9765 84.3875 85.4577 84.382 85.9886V88.1853C84.382 88.8496 84.5112 89.4249 84.7669 89.9087C85.0309 90.3925 85.4021 90.7664 85.8805 91.028C86.3589 91.2895 86.9253 91.4228 87.5825 91.4228C88.0169 91.4228 88.4156 91.3653 88.7785 91.2476C89.1415 91.13 89.4494 90.9547 89.7079 90.722C89.9664 90.4892 90.1616 90.2042 90.2963 89.8642L93.9203 90.0917C93.736 90.9207 93.3593 91.6425 92.7874 92.2623C92.2238 92.8743 91.4951 93.3528 90.5988 93.698C89.7106 94.0354 88.6823 94.2054 87.5165 94.2054V94.2001Z",
    fill: "url(#paint5_linear_9025_364538)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_9025_364538",
    x1: 17.7742,
    y1: 29.4096,
    x2: 60.8976,
    y2: 61.0478,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#69AEE6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#1275C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#0F60A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#0C4C81"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#0A3D69"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#09355A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#093255"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#0C3557"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#183E5F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#2C4F6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#476680"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#6A8398"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#96A7B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#C8D1D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_9025_364538",
    x1: 76.2258,
    y1: 29.4096,
    x2: 33.1024,
    y2: 61.0478,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#69AEE6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#1275C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#0F60A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#0C4C81"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#0A3D69"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#09355A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#093255"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#0C3557"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#183E5F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#2C4F6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#476680"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#6A8398"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#96A7B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#C8D1D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_9025_364538",
    x1: 24.761,
    y1: 49.5955,
    x2: 69.0486,
    y2: 49.5955,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#083658"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#92C2EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#A9CEEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#C3DDF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#D9EAF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#EAF3FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#F6FAFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#FDFDFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FDFDFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#F6FAFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#EAF3FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#D9EAF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#C3DDF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#A8CEEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#87BCE7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#62A7E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#3990D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#137BD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#083658"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_9025_364538",
    x1: 46.9782,
    y1: 11.5953,
    x2: 46.9782,
    y2: 61.5959,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#050F1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#0B1A2B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#0B1B2E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#0B2138"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#0C2B48"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#0D3960"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#0F4B7F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#1060A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#137BD1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_9025_364538",
    x1: 46.8295,
    y1: 37.2724,
    x2: 46.8295,
    y2: 43.7571,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#908A89"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_9025_364538",
    x1: 46.9574,
    y1: 70.0781,
    x2: 47.0121,
    y2: 100.1,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#062049"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1776D0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcMagpie);
export default __webpack_public_path__ + "static/media/ic_magpie.54de96f9dadbfdcf14d887f2a2781f4e.svg";
export { ForwardRef as ReactComponent };